import http from "@/utils/request";

export default {
  list: function (params) {
    const url = `/goods`;
    return http.get(url, { data: params });
  },
};
